<template>
    <div class="wrap">
        <div class="d-flex">
            <div class="mr-auto">
                <button class="btn btn-secondary" @click="refresh"><i class="fas fa-sync-alt"></i></button>
                <slot name="buttons"></slot>
            </div>
            <div class="align-self-end">
                <input-debounced
                        v-model="search"
                        :clearable="true"
                        :autofocus="true"
                        placeholder="Search"
                        class="search-bar w-300 mb-2"
                ></input-debounced>
            </div>
        </div>
        <base-table
                :base-url="urlWithFilters"
                ref="baseTable"
                @load-success="onLoadSuccess"
                @refresh="onRefresh"
                :current-page="currentPage"
                v-loading="isRefreshing"
                element-loading-spinner="el-icon-loading"
        >
            <template v-slot>
                <el-table
                        :data="items"
                        stripe
                        class="w-100"
                >
                    <el-table-column type="expand" v-slot="{row}">
                        <expand-column :row="row"></expand-column>
                    </el-table-column>
                    <el-table-column
                            prop="model.id"
                            label="Id"
                            min-width="80"
                    ></el-table-column>
                    <el-table-column
                            prop="model.group_name"
                            label="Group"
                            min-width="150"
                    ></el-table-column>
                    <el-table-column
                            prop="model.name"
                            label="Name"
                            min-width="300"
                            :formatter="formatName"
                    ></el-table-column>
                    <el-table-column
                            prop="model.value"
                            label="Value"
                            min-width="300"
                    ></el-table-column>
                    <el-table-column
                            label="Actions"
                            v-slot="{row}"
                    >
                        <actions-column :row="row" @edit="onEdit"></actions-column>
                    </el-table-column>
                </el-table>
            </template>
        </base-table>
        <el-pagination
                layout="prev, pager, next"
                :total="total"
                :current-page.sync="currentPage"
                :page-size="pageSize"
                class="text-right"
        ></el-pagination>
    </div>
</template>

<script>
  import TableWithPagination from '../table-with-pagination';
  import {addQueryParams} from '../../libs/url';
  import ActionsColumn from './actions-column';
  import ExpandColumn from './expand-column';

  export default {
    extends: TableWithPagination,

    components: {
      ActionsColumn,
      ExpandColumn,
    },

    data() {
      return {
        search: null,
        filters: {},
      };
    },

    computed: {
      /**
       * @return {string}
       */
      urlWithFilters() {
        return addQueryParams(this.url, this.filters);
      },
    },

    watch: {
      search: function (value) {
        if (value) {
          this.filters = _.assign({}, this.filters, {search: value});
        } else {
          this.filters = _.omit(this.filters, ['search']);
        }
      },
    },

    methods: {
      /**
       * @return {string}
       */
      formatName(row, col, value) {
        return value || _.get(row, 'key');
      },

      /**
       * @return {undefined}
       */
      refresh() {
        this.$refs.baseTable.refresh();
      },

      /**
       * @param {string} url
       * @event show-add-setting-dialog
       */
      onEdit({url}) {
        eventBus.$emit('show-edit-setting-dialog', url);
      },
    }
  }
</script>
